import * as React from 'react';
import { connect } from 'react-redux';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Form, Field } from 'react-final-form';
import {
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';
import { get } from 'lodash';

import { buttonStyles, media } from '../../../styles/base';
import TextField from '../../utility/TextField';
import { submitContactForm } from '../../../actions/contact';
import validations, { composeValidators } from '../../../lib/validation';
import Messages, { MessagesTypes } from '../../utility/Messages';
import track from '../../../lib/track';
import { STATES_LIST } from '../../../lib/constants';
import combineStyles from '../../../styles/combineStyles';
import { normalizePhone } from '../../../lib/helpers';

const styles = createStyles({
  checkboxWrapper: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
  },
  contactInput: {
    borderRadius: 20,
  },
  contactSubmit: {
    '&:hover': {
      backgroundColor: '#ffffff',
      color: '#195A50',
    },
    backgroundColor: '#195A50',
    borderRadius: '24px',
    color: '#ffffff',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    height: '56px',
    lineHeight: '24px',
    padding: '16px 24px',
    textTransform: 'none',
    width: '100%',
  },
  errorText: {
    color: '#f44336 !important',
  },
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 1000,
    [media.mobile]: {
      height: 488,
    },
  },
  successHeading: {
    fontFamily: 'Sharp Grotesk Semibold',
    fontSize: 32,
    fontWeight: 600,
    lineHeight: 41,
    color: '#2D2332',
    textAlign: 'center',
    marginTop: 32,
    [media.mobile]: {
      width: 290,
    },
  },
  successDesc: {
    fontFamily: 'Poppins',
    fontSize: 19.2,
    fontWeight: 400,
    lineHeight: 29,
    color: '#2D2332',
  },
});
interface Props {
  classes: any;
  dispatch: any;
  initialValues: any;
  messages: MessagesTypes;
}

interface State {
  contactByEmail: boolean;
  contactByPhone: boolean;
  key: number;
  messageSent: boolean;
}

export class ContactForm extends React.Component<Props, State> {
  formRef: any;
  constructor(props: Props) {
    super(props);
    this.state = {
      contactByEmail: false,
      contactByPhone: false,
      key: 0,
      messageSent: false,
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    if (Object.keys(this.props.initialValues).length > 0) {
      window.scrollTo(0, this.formRef.current.offsetTop);
    }
  }

  handleCheckboxChange = (event: any) => {
    // @ts-ignore
    this.setState({ [event.target.name]: event.target.checked });
  };
  handleSubmit = (values: any) => {
    const { address, subject } = this.props.initialValues;
    values.subject =
      subject || `Torii Web - Request Info${address ? ` - ${address}` : ''}`;
    values.name = `${values.firstName} ${values.lastName}`;
    values.contactByEmail = this.state.contactByEmail;
    values.contactByPhone = this.state.contactByPhone;
    track.submitContactForm(values);
    this.props.dispatch(submitContactForm(values));
    this.reInitialize();
  };

  reInitialize = () => {
    this.setState({ messageSent: true });
    if (this.state.key === 0) {
      this.setState({ key: 1, contactByEmail: false, contactByPhone: false });
    } else {
      this.setState({ key: 0, contactByEmail: false, contactByPhone: false });
    }
  };
  render() {
    const { classes, initialValues } = this.props;
    if (this.state.messageSent) {
      // TODO: Add the new design
      // You can add the css in the same file with existing css on top
      return (
        <div className={classes.successContainer}>
          <img
            src={'/static/img/contact/mailSent.svg'}
            className="mail"
            alt="mail-sent"
          />
          <h3 className={classes.successHeading}>
            Your message has been sent!
          </h3>
          <p className={classes.successDesc}>
            We&#39;ll get back to you shortly.
          </p>
        </div>
      );
    }
    return (
      <div ref={this.formRef}>
        <h3>
          Send us a message, and we&#39;ll be in touch as soon as possible.
        </h3>
        <Form
          key={this.state.key}
          initialValues={initialValues}
          onSubmit={this.handleSubmit}
          render={({ handleSubmit, valid }) => (
            <div>
              <Field
                component={TextField}
                fullWidth
                label="First Name"
                margin="normal"
                name="firstName"
                type="text"
                validate={validations.required}
                variant="outlined"
                FormHelperTextProps={{
                  classes: {
                    error: classes.errorText,
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.contactInput,
                  },
                }}
              />
              <br />
              <Field
                component={TextField}
                fullWidth
                label="Last Name"
                margin="normal"
                name="lastName"
                type="text"
                validate={validations.required}
                variant="outlined"
                FormHelperTextProps={{
                  classes: {
                    error: classes.errorText,
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.contactInput,
                  },
                }}
              />
              <br />
              <Field
                component={TextField}
                fullWidth
                label="Phone Number"
                margin="normal"
                name="phoneNumber"
                type="text"
                placeholder="123-456-7890"
                validate={composeValidators(
                  validations.required,
                  validations.phoneNumber,
                )}
                format={normalizePhone}
                variant="outlined"
                inputProps={{ inputMode: 'numeric' }}
                FormHelperTextProps={{
                  classes: {
                    error: classes.errorText,
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.contactInput,
                  },
                }}
              />
              <br />
              <Field
                component={TextField}
                fullWidth
                label="Email Address"
                margin="normal"
                name="email"
                type="email"
                placeholder="email@email.com"
                validate={composeValidators(
                  validations.required,
                  validations.email,
                )}
                variant="outlined"
                FormHelperTextProps={{
                  classes: {
                    error: classes.errorText,
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.contactInput,
                  },
                }}
              />
              <br />
              <Field
                component={TextField}
                fullWidth
                label="Subject"
                margin="normal"
                name="subject"
                type="text"
                validate={validations.required}
                variant="outlined"
                FormHelperTextProps={{
                  classes: {
                    error: classes.errorText,
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.contactInput,
                  },
                }}
              />
              <br />
              {/* <br />
              <Field
                component={(props: any) => {
                  return (
                    <FormControl variant="outlined" style={{ width: '100%' }}>
                      <InputLabel id="loc">Location</InputLabel>
                      <Select
                        labelId="loc"
                        id="loc"
                        variant="outlined"
                        label="Location"
                        error={props.meta.touched && props.meta.error}
                        onChange={(event: any) =>
                          props.input.onChange(event.target.value)
                        }
                        style={{
                          borderRadius: 20,
                          textAlign: 'left',
                          width: '100%',
                        }}
                        value={get(props, 'input.value', '')}
                        classes={{
                          outlined: classes.contactInput,
                        }}
                      >
                        {Object.keys(STATES_LIST).map(
                          (item: any, index: number) => {
                            return (
                              <MenuItem key={index} value={item}>
                                {`${STATES_LIST[item]}`}
                              </MenuItem>
                            );
                          },
                        )}
                      </Select>
                    </FormControl>
                  );
                }}
                name="location"
                required
                type="text"
                validate={composeValidators(validations.required)}
              /> */}
              <Field
                component={TextField}
                fullWidth
                label="How can we help?"
                margin="normal"
                multiline
                name="message"
                placeholder="Tell us what you need..."
                rows={10}
                validate={validations.required}
                variant="outlined"
                FormHelperTextProps={{
                  classes: {
                    error: classes.errorText,
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.contactInput,
                  },
                }}
              />
              <br />
              <div className={classes.checkboxWrapper}>
                <p style={{ fontSize: 16 }}>How should we contact you?</p>
                <FormControlLabel
                  control={
                    // tslint:disable-next-line: jsx-wrap-multiline
                    <Checkbox
                      color="primary"
                      checked={this.state.contactByEmail}
                      onChange={this.handleCheckboxChange}
                      name="contactByEmail"
                    />
                  }
                  label="Email"
                />
                <FormControlLabel
                  control={
                    // tslint:disable-next-line: jsx-wrap-multiline
                    <Checkbox
                      color="primary"
                      checked={this.state.contactByPhone}
                      onChange={this.handleCheckboxChange}
                      name="contactByPhone"
                    />
                  }
                  label="Phone"
                />
              </div>
              <br />
              <Button
                className={classes.contactSubmit}
                disabled={
                  !valid ||
                  (!this.state.contactByEmail && !this.state.contactByPhone)
                }
                size="medium"
                variant="contained"
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </div>
          )}
        />
      </div>
    );
  }
}

const combinedStyles = combineStyles(buttonStyles, styles);
const mapStateToProps = (state: any) => ({
  messages: state.messages,
});

export default connect(mapStateToProps)(
  withStyles(combinedStyles)(ContactForm),
);
